/* eslint no-param-reassign: 0 */

import { combineReducers } from 'redux'
import { appReducer as app } from './containers/App/appReducer'
import { cartReducer as cart } from './containers/Cart/cartReducer'
import { CLOSE_APP } from './containers/App/constants'
const appReducer = combineReducers({
  app,
  cart,
})

export default (state, action) => {
  if (action.type === CLOSE_APP) {
    state = { app: { locale: state.app.locale, messages: state.app.messages } }
  }
  return appReducer(state, action)
}

export * from './containers/App/appReducer'
export * from './containers/Cart/cartReducer'



// WEBPACK FOOTER //
// ./src/rootReducer.js